export const DOMAINS = {
  ABBOTT_ADMINISTRATION: 'abbott-administration',
  CUSTOMER_ADMINISTRATION: 'customer-administration',
  USER_ADMINISTRATION: 'user-administration',
  EDUCATION: 'education',
  OUTPATIENT: 'outpatient',
} as const;

export type Domain = (typeof DOMAINS)[keyof typeof DOMAINS];
